import { useEffect } from 'react'
import { navigateToUrl } from 'single-spa'

export function Redirect({ url }) {
  useEffect(() => {
    navigateToUrl(url)
  }, [url])

  return <></>
}
